//import netteForms from 'nette-forms'
import Nette from 'nette-forms'
//import naja from 'naja'

//netteForms.initOnLoad()
//naja.formsHandler.netteForms = netteForms

Nette.showFormErrors = (form, errors) => {
	// Zdroj: https://github.com/nette/forms/blob/master/src/assets/netteForms.js, upraveno
	let focusElem

	form.querySelectorAll('._nette-forms_input').forEach(element => {
		const errorMsg = document.querySelector(`._nette-forms_msg[data-id="${element.dataset.for}"]`)

		if (!element.className.includes('_choices-multiselect') && !element.className.includes('_choices-select')) {
			element.classList.remove('is-invalid')
			element.classList.add('is-valid')
		} else {
			const choices = element.closest('.choices');

			choices.classList.remove('is-invalid')
			choices.classList.add('is-valid')
		}

		errorMsg.innerText = ''
	})

	for (let i = 0; i < errors.length; i++) {
		const element = errors[i].element,
			message = errors[i].message
		const errorMsg = document.querySelector(`._nette-forms_msg[data-id="${element.dataset.for}"]`)

		if (!element.className.includes('_choices-multiselect') && !element.className.includes('_choices-select')) {
			element.classList.remove('is-valid')
			element.classList.add('is-invalid')
		} else {
			const choices = element.closest('.choices');

			choices.remove('is-valid')
			choices.classList.add('is-invalid')
		}

		// Nekdy je validace privadena mimo nette-forms, takze nemusi existovat prislusny element pro chybovou zpravu
		if (errorMsg) {
			errorMsg.innerText += errorMsg.innerText === '' ? message : '\n' + message
		}

		if (!focusElem && element.focus) {
			focusElem = element
		}
	}
}

Nette.toggle = (selector, visible, _1, _2) => {
	document.querySelectorAll(selector).forEach(element => {
		// Minoritni zmena (trida konci --minor) se ignoruje, pokud je element skryty pomoci majoritni zmeny
		if (visible && selector.endsWith('--minor') && element.dataset.majorHide === 'true') {
			return
		}

		if (visible) {
			element.classList.add('show')
			element.dataset.majorHide = 'false'
			return
		}

		element.classList.add('collapse')
		element.classList.remove('show')
		element.dataset.majorHide = !selector.endsWith('--minor') ? 'true' : 'false'
	})
}
